import { useCallback } from 'react'
import {useAuth} from "@clerk/clerk-react"

export const useApi = () => {
  const {getToken} = useAuth()

  const makeRequest = useCallback(async (endpoint, options = {}) => {
    const token = await getToken()

    // If token is null, Clerk hasn't finished loading yet
    if (!token) {
      throw new Error('Authentication not ready. Please wait a moment and try again.')
    }

    // Get API URL from environment variable with fallback to localhost
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'

    // Remove leading slash from endpoint if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint

    // Merge headers properly to avoid overwriting
    const mergedOptions = {
      ...options,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        ...(options.headers || {})
      }
    }

    const response = await fetch(`${apiUrl}/api/${cleanEndpoint}`, mergedOptions)

    if (!response.ok) {
      const errorData = await response.json().catch(() => null)
      if (response.status === 429) {
        throw new Error(errorData?.detail || "Rate limit exceeded. Please upgrade your plan or try again later.")
      }
      if (response.status === 404) {
        throw new Error(errorData?.detail || "Resource not found")
      }
      if (response.status === 403) {
        throw new Error(errorData?.detail || "Access denied")
      }
      throw new Error(errorData?.detail || "An error occurred")
    }

    return response.json()
  }, [getToken])

  return {makeRequest}
}
